class RichTextReadMore extends HTMLElement {
  constructor() {
    super();

    this.content = null;
    this.button = null;
    this.isExpanded = false;

    this.handleClick = this.handleClick.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    this.content = this.querySelector('[data-read-more-content]');
    this.button = this.querySelector('[data-read-more-toggle]');

    if (!this.content || !this.button) {
      return;
    }

    this.collapsedHeight = parseInt(this.dataset.collapsedHeight, 10);
    this.collapsedLabel = this.dataset.collapsedLabel || 'Mehr lesen';
    this.expandedLabel = this.dataset.expandedLabel || 'Weniger anzeigen';

    if (!this.collapsedHeight || this.collapsedHeight <= 0) {
      return;
    }

    this.button.addEventListener('click', this.handleClick);
    window.addEventListener('resize', this.handleResize);

    this.initialize();
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.handleClick);
    window.removeEventListener('resize', this.handleResize);
  }

  initialize() {
    // Wait until the browser has calculated the actual content height.
    requestAnimationFrame(() => {
      const contentHeight = this.content.scrollHeight;

      // If the content is already shorter than the collapsed height, there is nothing to expand.
      if (contentHeight <= this.collapsedHeight) {
        this.button.hidden = true;
        this.content.style.maxHeight = 'none';
        return;
      }

      this.button.hidden = false;
      this.content.style.maxHeight = `${this.collapsedHeight}px`;
      this.content.classList.add('is-collapsed');
      this.button.setAttribute('aria-expanded', 'false');
      this.button.textContent = this.collapsedLabel;
    });
  }

  handleClick() {
    this.isExpanded = !this.isExpanded;

    if (this.isExpanded) {
      this.expand();
    } else {
      this.collapse();
    }
  }

  expand() {
    // Set the current collapsed height first so the browser has a starting point for the animation.
    this.content.style.maxHeight = `${this.collapsedHeight}px`;

    requestAnimationFrame(() => {
      const expandedHeight = this.content.scrollHeight;

      this.content.style.maxHeight = `${expandedHeight}px`;
      this.content.classList.remove('is-collapsed');
      this.content.classList.add('is-expanded');
      this.button.setAttribute('aria-expanded', 'true');
      this.button.textContent = this.expandedLabel;
    });
  }

  collapse() {
    // Start from the actual current height.
    this.content.style.maxHeight = `${this.content.scrollHeight}px`;

    requestAnimationFrame(() => {
      this.content.style.maxHeight = `${this.collapsedHeight}px`;
      this.content.classList.remove('is-expanded');
      this.content.classList.add('is-collapsed');

      this.button.setAttribute('aria-expanded', 'false');
      this.button.textContent = this.collapsedLabel;
    });
  }

  handleResize() {
    if (this.button.hidden) {
      return;
    }

    if (this.isExpanded) {
      // Recalculate the height because text wrapping changes between desktop and mobile.
      this.content.style.maxHeight = `${this.content.scrollHeight}px`;
    }
  }
}

if (!customElements.get('rich-text-read-more')) { customElements.define('rich-text-read-more', RichTextReadMore); }